import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0821b041&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0821b041&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0821b041')) {
      api.createRecord('0821b041', component.options)
    } else {
      api.reload('0821b041', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0821b041&", function () {
      api.rerender('0821b041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelEdit/index.vue"
export default component.exports